module.exports = __webpack_public_path__ + "static/img/qrcode.93ac713.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/qrcode.jpeg
// module id = 3HXX
// module chunks = 4